<template>
  <div class="list-page">
    <div class="bg-decoration"></div>
    <div class="bg-decoration-2"></div>

    <div class="main-content">
      <!-- 未通过签名验证引导 -->
      <div v-if="!authVerified" class="no-access">
        <div v-if="authVerifying" class="no-access-card">
          <i class="el-icon-loading no-access-icon"></i>
          <p class="no-access-title">正在验证身份...</p>
        </div>
        <div v-else-if="authDeniedReason" class="no-access-card denied">
          <i class="el-icon-warning no-access-icon"></i>
          <p class="no-access-title">无法参与活动</p>
          <p class="no-access-desc">{{ authDeniedReason }}</p>
        </div>
        <div v-else class="no-access-card">
          <i class="el-icon-warning-outline no-access-icon"></i>
          <p class="no-access-title">请通过App内活动链接进入</p>
          <p class="no-access-desc">本页面需在陌撩漂流瓶App内打开，方能识别您的身份并参与活动。</p>
        </div>
      </div>

      <template v-else>
      <!-- 头部 -->
      <div class="page-header">
        <div class="brand">
          <img src="https://img.moliaos.com/v/logo.png" class="brand-logo" alt="陌撩漂流瓶" />
          <span class="brand-name">陌撩漂流瓶</span>
        </div>
        <h1 class="page-title">活动中心</h1>
        <p class="page-subtitle">参与活动，赢取丰厚奖励</p>
      </div>


      <!-- 活动列表 -->
      <div class="activity-list">
        <div
          v-for="item in activities"
          :key="item.id"
          class="activity-card"
          :class="{ ended: statusOf(item) === 'ended', pending: statusOf(item) === 'pending' }"
          @click="goActivity(item)"
        >
          <!-- 封面 -->
          <div class="card-cover" :style="{ background: item.cover }">
            <i :class="item.icon" class="cover-icon"></i>
            <span class="cover-tag">{{ item.tag }}</span>
            <span class="status-badge" :class="statusOf(item)">
              {{ statusText(item) }}
            </span>
          </div>

          <!-- 内容 -->
          <div class="card-body">
            <div class="card-name">{{ item.name }}</div>

            <div class="info-row">
              <i class="el-icon-time"></i>
              <span class="info-label">活动时间</span>
              <span class="info-value">{{ item.timeText }}</span>
            </div>

            <div class="info-row">
              <i class="el-icon-edit"></i>
              <span class="info-label">参与方式</span>
              <span class="info-value">{{ item.join }}</span>
            </div>

            <div class="info-row">
              <i class="el-icon-coin"></i>
              <span class="info-label">奖励说明</span>
              <span class="info-value reward">{{ item.reward }}</span>
            </div>

            <div class="card-footer">
              <span class="footer-tip">{{ footerTip(item) }}</span>
              <span class="footer-arrow">
                {{ footerArrow(item) }}
                <i v-if="statusOf(item) === 'active'" class="el-icon-arrow-right"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom-bar">
        <div class="copyright">© 2026 陌撩漂流瓶</div>
        <div class="version-tag">v 1.1.0</div>
      </div>
      </template>
    </div>
  </div>
</template>

<script>
import { setToken } from '@/utils/dataStorage.js'
import { setAuthParams, buildAuthQuery, isAuthParamsComplete } from '@/utils/authParams.js'
import { VerifySignatureApi } from '@/api/api.js'

export default {
  name: 'ActivityList',
  data() {
    return {
      userId: '',
      authVerified: false,
      authVerifying: true,
      authDeniedReason: '',
      token: '',
      activities: [
        {
          id: 'cashback2',
          name: '限定活动·提现奖励',
          tag: '奖励10%',
          icon: 'el-icon-present',
          cover: 'linear-gradient(135deg, #ff8a3d 0%, #ff4d8d 50%, #a855f7 100%)',
          startTime: '2026.10.31',
          endTime: '2026.12.31',
          timeText: '2026.10.31 - 2026.12.31',
          join: '活动期间累计提现达标即可奖励',
          reward: '提现满条件最高返10%',
          route: '/activity/cashback2'
        },
        {
          id: 'invite',
          name: '限时邀请奖励活动',
          tag: '奖励10%',
          icon: 'el-icon-coin',
          cover: 'linear-gradient(135deg, #ff60c5 0%, #a855f7 100%)',
          startTime: '2026-07-17',
          endTime: '2026-12-31',
          timeText: '2026.07.17 - 2026.12.31',
          join: '分享专属邀请码，好友绑定即生效',
          reward: '好友提现奖励10%，多邀多得',
          route: '/activity/invite'
        },
        {
          id: 'feedback',
          name: '问题反馈有奖活动',
          tag: '反馈有奖',
          icon: 'el-icon-edit-outline',
          cover: 'linear-gradient(135deg, #a855f7 0%, #6366f1 100%)',
          startTime: '2026-07-17',
          endTime: '2026-12-31',
          timeText: '2026.07.17 - 2026.12.31',
          join: '提交APP问题反馈，经审核采纳',
          reward: '采纳奖励2-50元现金',
          route: '/activity/feedback'
        },
//      {
//          id: 'cashback',
//          name: '限定活动·热力开启',
//          tag: '奖励20%',
//          icon: 'el-icon-present',
//          cover: 'linear-gradient(135deg, #ff8a3d 0%, #ff4d8d 50%, #a855f7 100%)',
//          startTime: '2026-09-18',
//          endTime: '2026-09-24',
//          timeText: '2026.09.18 - 2026.09.24',
//          join: '活动期间累计提现达标即可奖励',
//          reward: '提现满条件最高返20%',
//          route: '/activity/cashback'
//       },
      ]
    }
  },
  mounted() {
    const query = this.$route.query || {};
    if (query.token) {
      this.token = query.token;
      setToken(query.token);
    }
    // 参数完整性检查：签名参数齐全才请求后端验证签名
    if (isAuthParamsComplete(query)) {
      setAuthParams(query);
      VerifySignatureApi().then(res => {
        if (res && res.code === 200 && res.data && res.data.user_id) {
          this.userId = String(res.data.user_id);
          this.authVerified = true;
        } else {
          this.authVerified = false;
        }
      }).catch(err => {
        // 提取 403 业务限制原因（性别限制/黑名单等），显示友好的限制提示卡片
        const detail = err && err.response && err.response.data && err.response.data.detail;
        if (detail) {
          this.authDeniedReason = detail;
        }
        this.authVerified = false;
      }).finally(() => {
        this.authVerifying = false;
      });
    } else {
      // 参数不全，直接拒绝
      this.authVerified = false;
      this.authVerifying = false;
    }
  },
  methods: {
    onHeroClick() {
      const el = document.querySelector('.activity-card');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    // 活动状态判定：pending=待开启, active=进行中, ended=已结束
    statusOf(item) {
      const now = new Date();
      if (item.startTime) {
        const start = new Date(item.startTime + 'T00:00:00');
        if (now < start) return 'pending';
      }
      if (item.endTime) {
        const end = new Date(item.endTime + 'T23:59:59');
        if (now > end) return 'ended';
      }
      return 'active';
    },
    statusText(item) {
      const map = { pending: '待开启', active: '进行中', ended: '已结束' };
      return map[this.statusOf(item)];
    },
    footerTip(item) {
      const map = { pending: '活动未开始', active: '点击参与', ended: '活动已结束' };
      return map[this.statusOf(item)];
    },
    footerArrow(item) {
      const map = { pending: '敬请期待', active: '查看详情', ended: '查看记录' };
      return map[this.statusOf(item)];
    },
    goActivity(item) {
      // 仅进行中的活动允许进入详情页
      if (this.statusOf(item) !== 'active') return;
      this.$router.push({ path: item.route, query: buildAuthQuery(this.$route.query) });
    }
  }
}
</script>

<style scoped>
.list-page {
  min-height: 100vh;
  background: linear-gradient(160deg, #fff5f9 0%, #fff9ff 40%, #fdf2f8 100%);
  position: relative;
  overflow: hidden;
}

.bg-decoration {
  position: absolute;
  top: -160px;
  right: -160px;
  width: 420px;
  height: 420px;
  background: radial-gradient(circle, rgba(255, 96, 197, 0.18) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.bg-decoration-2 {
  position: absolute;
  bottom: -120px;
  left: -120px;
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, rgba(168, 85, 247, 0.12) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 8s ease-in-out infinite reverse;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(20px, 20px) scale(1.08); }
}

.main-content {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 28px 18px 40px;
  position: relative;
  z-index: 1;
}

/* 头部 */
.page-header {
  text-align: center;
  margin-bottom: 24px;
}
.brand {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}
.brand-logo {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  margin-right: 8px;
  box-shadow: 0 4px 12px rgba(255, 96, 197, 0.25);
}
.brand-name {
  font-size: 16px;
  font-weight: 700;
  background: linear-gradient(135deg, #ff60c5 0%, #a855f7 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.page-title {
  font-size: 26px;
  font-weight: 800;
  color: #333;
  margin-bottom: 6px;
  letter-spacing: 1px;
}
.page-subtitle {
  font-size: 13px;
  color: #999;
}

/* 活动卡片 */
.activity-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.activity-card {
  background: #fff;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 10px 32px rgba(255, 96, 197, 0.12);
  border: 1px solid rgba(255, 96, 197, 0.06);
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.activity-card:active {
  transform: scale(0.98);
}
.activity-card.pending,
.activity-card.ended {
  opacity: 0.78;
  filter: grayscale(0.2);
  cursor: not-allowed;
}

/* 封面 */
.card-cover {
  position: relative;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.card-cover::after {
  content: '';
  position: absolute;
  top: -30px;
  right: -30px;
  width: 120px;
  height: 120px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
  border-radius: 50%;
}
.cover-icon {
  font-size: 48px;
  color: #fff;
  z-index: 1;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.cover-tag {
  position: absolute;
  top: 12px;
  left: 14px;
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 12px;
  backdrop-filter: blur(4px);
}
.status-badge {
  position: absolute;
  top: 12px;
  right: 14px;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 10px;
}
.status-badge.active {
  background: #fff;
  color: #ff4d8d;
}
.status-badge.pending {
  background: #fff;
  color: #ff9800;
}
.status-badge.ended {
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
}

/* 内容 */
.card-body {
  padding: 16px 16px 14px;
}
.card-name {
  font-size: 17px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
}
.info-row {
  display: flex;
  align-items: flex-start;
  font-size: 13px;
  margin-bottom: 8px;
  line-height: 1.5;
}
.info-row i {
  color: #ff8fcc;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
}
.info-label {
  color: #999;
  margin-right: 8px;
  flex-shrink: 0;
}
.info-value {
  color: #555;
  flex: 1;
  word-break: break-all;
}
.info-value.reward {
  color: #ff4d8d;
  font-weight: 600;
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #f0d6e6;
}
.footer-tip {
  font-size: 12px;
  color: #bbb;
}
.footer-arrow {
  font-size: 13px;
  font-weight: 600;
  color: #ff60c5;
  display: flex;
  align-items: center;
}
.footer-arrow i {
  margin-left: 4px;
  font-size: 12px;
}

/* 未授权引导 */
.no-access-card {
  background: #fff;
  border-radius: 24px;
  padding: 56px 28px;
  text-align: center;
  box-shadow: 0 12px 40px rgba(255, 96, 197, 0.12);
  margin-top: 80px;
}
.no-access-card.denied {
  border: 1px solid #fde2e2;
  background: linear-gradient(135deg, #fff5f5 0%, #fff0f5 100%);
}
.no-access-card.denied .no-access-icon {
  color: #f56c6c;
}
.no-access-icon {
  font-size: 52px;
  color: #ff60c5;
  margin-bottom: 16px;
  display: block;
}
.no-access-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}
.no-access-desc {
  font-size: 14px;
  color: #999;
  line-height: 1.7;
}

.bottom-bar {
  text-align: center;
  margin-top: 28px;
}
.copyright {
  font-size: 12px;
  color: #ccc;
}
.version-tag {
  margin-top: 4px;
  font-size: 11px;
  color: #d8d8d8;
  letter-spacing: 0.5px;
}

@media (min-width: 481px) {
  .main-content {
    padding: 44px 18px 52px;
  }
  .page-title {
    font-size: 30px;
  }
}

@media (max-width: 360px) {
  .page-title {
    font-size: 22px;
  }
  .card-name {
    font-size: 16px;
  }
  .info-row {
    font-size: 12px;
  }
}
</style>
